module.exports = __webpack_public_path__ + "img/drag-purple.f0ab0e09.svg";